// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"76b612a9","176":"70290658","213":"de49008c","239":"6ca86103","355":"963a0e5b","371":"bf979211","402":"48ebb312","455":"9d3289fd","626":"edfc0c2e","757":"5bea18bb"}[chunkId] + ".chunk.js";
};